module.exports = __webpack_public_path__ + "static/img/5G通讯数字展厅.006cf69a.png";